import { render, staticRenderFns } from "./AgentFeaturePromotionBanner.vue?vue&type=template&id=3d5cef7c&scoped=true"
import script from "./AgentFeaturePromotionBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentFeaturePromotionBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AgentFeaturePromotionBanner.vue?vue&type=style&index=0&id=3d5cef7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5cef7c",
  null
  
)

export default component.exports